import { errorClient } from "@product-details/clients/ErrorClient";

export const handleError = (message: string) => {
  errorClient.reportError(message);
};
